"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveScopedInstanceBindingNode = void 0;
const getInstanceNodeBinding_1 = require("../calculations/getInstanceNodeBinding");
const resolveScoped_1 = require("./resolveScoped");
const resolveScopedInstanceBindingNode = (resolve) => (0, resolveScoped_1.resolveScoped)(getInstanceNodeBinding_1.getInstanceNodeBinding, resolve);
exports.resolveScopedInstanceBindingNode = resolveScopedInstanceBindingNode;
//# sourceMappingURL=resolveScopedInstanceBindingNode.js.map